import React, {useCallback} from 'react';
import cx from 'classnames';
import {Text, Flex, CheckBox} from '@priority-software/priority-style-react';
import {highlightText} from '../../../../_legacy/library/utils/highlightText';
import {getTopDialogZindex} from '../../../../_shared/GWTBridge/invoke/priModalDlg';
import texts from '../../../../features/MoreInfo/texts';
import styles from './styles.module.scss';
import {Tooltip} from '../../../Common/Tooltip';

export const SearchableFieldItem = ({
    item,
    isSelected,
    isReachedLimit,
    inputValue,
    addItem,
    deleteItem,
    selectedValues
}) => {
    const onToggle = useCallback(() => {
        const itemToDelete = selectedValues.find(selectedItem => selectedItem.id === item.id);
        itemToDelete ? deleteItem(itemToDelete.id) : addItem(item);
    }, [addItem, item, isSelected]);

    return (
        <div
            className={cx(styles.listItem, {
                [styles.disabled]: isSelected
            })}
        >
            <Flex componentClasses={styles.inner} justifyContent="flex-start">
                <Tooltip
                    tooltip={isReachedLimit && !isSelected && texts.max_amount_msg}
                    zIndex={getTopDialogZindex()}
                    delay={200}
                >
                    <CheckBox
                        checked={isSelected}
                        onChange={onToggle}
                        disabled={
                            (selectedValues.length === 1 && isSelected) ||
                            (isReachedLimit && !isSelected)
                        }
                    />
                </Tooltip>
                <Text tag="div" skin="paragraph-2" textColor="primary-700">
                    {!isSelected ? highlightText(item.label, inputValue) : item.label}
                </Text>
            </Flex>
        </div>
    );
};
